// bamQueue.addToQueue(function(){
	/********************/
	/*	 FORMULARIOS	*/
	/********************/
/*
	$('form[data-abide]').off('submit.bam').on('submit.bam', function(ev,frm) {
		ev.preventDefault();
	})

*/
	var isFullVersion = false;

	function setFullVersionEnvironment(status){
		isFullVersion = status;
		setResizeEvents();
	}
	function getFullVersionEnvironment(){
		return isFullVersion;
	}
	$(document).on('submit','form[data-abide]',function(ev,frm) {
		ev.preventDefault();
	})

	//***********************************************************************************

	function mainStringifiedLaunches(strings){
		bamQueue.addToQueue(function(){
			setChildLimiter($('[data-participants][data-limit]'),{
				strings:{
					remaining: strings.strings.remaining
				}
			})
			setChildLimiter($('ul.extrasList[data-limit]'),{
				strings:{
					remaining: strings.strings.remaining
				}
// 				,limit:20
			})
			setChildLimiter($('#fondoBets [data-club-development]'),{
				strings:{
					remaining: strings.strings.remaining
				},
				limit:100
			})
		})
	}



	// 	setJackpotAnimations(2000);
		function openNotificationsBox(){
			if($("#notifications").attr("aria-hidden")=="true") {
				$('#notifications [data-notificationData]').removeClass('is-active');
				notificationsLoader = new loaderProObject($('#notifications ul.list'),{ enabledOnLoad:true,insertBefore:true});
				myForm = new formeSubmit(false,"/data/?action=notifications",
				{
					callbackOnSuccess: function (e) {
						//$("#notifications ul")
						if(Object.keys(e.data[0]).length>0) {
							$("#notifications ul").html("");
							$.each(e.data[0],function(key,val){
								var li = "<li class="+val.disabled+">";
								if(val.tipo == 1){
									li += "<span><img src='"+val.concepto.avatar+"' class='avatar'></span>";
									//li += "<span><i class='icon-games-groups'></i></span>";
									li += "<span><a href='"+val.concepto.url+"'>"+val.concepto.grupo+"</a></span>";
									li += "<span>"+val.concepto.descripcion+"</span>";
									li += "<span>"+val.fechaFormat+"</span>";
								} else if(val.tipo==2) {
									li += "<span><img src='"+val.concepto.avatar+"' class='avatar'></span>";
									//li += "<span><i class='icon-games-groups'></i></span>";
									li += "<span><a href='"+val.concepto.url+"'>"+val.concepto.grupo+"</a></span>";
									if(val.aceptada == 0) {
										li += "<span><strong><a href='"+val.concepto.url+"'>"+e.data.lang.verInvitacion+"</a></strong></span>";
									}
									else if(val.aceptada == 1) {
										li += "<span>"+e.data.lang.aceptada+"</span>";
									}
									else {
										li += "<span>"+e.data.lang.rechazada+"</span>";
									}
									li += "<span>"+val.fechaFormat+"</span>";
								} else if(val.tipo==3) {
									li += "<span><i class='icon-games-"+val.concepto.tipo+"'></i></span>";
									li += "<span>"+e.data.lang.num+": <strong>"+val.concepto.numero+"</strong></span>";
									li += "<span>"+val.concepto.descripcion+"</span>";
									li += "<span>"+val.fechaFormat+"</span>";
								}
								$("#notifications ul").append(li);
							});
							$('[data-usernotifications] span.badge').remove();
							$('[data-usernotifications] button').removeAttr('data-alarm');
							/*if(e.data[1]>0) {
								$("#notifications").find("button").prop("disabled",false);
								$("[data-notifications] span[data-notiCounter]").html(e.data[1]);
							}*/
						}
						notificationsLoader.stop();
						$('#notifications [data-notificationData]').addClass('is-active');
					},
				});
			}
		}

	bamQueue.addToQueue(function(){

		/****************************/
		/*	 DETECTOR DE ACTIVIDAD	*/
		/****************************/
		bamQueue.waitForExistance("ifvisible",function(){
			window.inactivityTime = false;
			window.inactivityInterval = false;
			ifvisible.on("focus",function(){
 				console.log("ON")
				window.inactivityTime = false;
				clearInterval(window.inactivityInterval);
			})
			ifvisible.on("blur",function(){
 				console.log("OFF")
				if(typeof window.inactivityTime == Boolean){
					window.inactivityTime = 0;
				}else{
					clearInterval(window.inactivityInterval);
				}
				window.inactivityInterval = setInterval(function(){
					window.inactivityTime ++;
				}, 1000)
			})
			ifvisible.on("idle", function(){
 				console.log("IDLE")
				if(typeof window.inactivityTime == Boolean){
					window.inactivityTime = 0;
				}else{
					clearInterval(window.inactivityInterval);
				}
				window.inactivityInterval = setInterval(function(){
					window.inactivityTime ++;
				}, 1000)
			});
			ifvisible.on("wakeup", function(){
				console.log("AWAKEN")
				clearInterval(window.inactivityInterval);
				window.inactivityTime = false;
			});
			ifvisible.setIdleDuration(5);
		},1000,20)
/* 		window.inactivityTime = false;
		window.inactivityInterval = false;
		window.iframeMouseOver = false;
		window.inactivityInterval = setInterval(function(){
			window.inactivityTime ++;
		}, 1000); */

		$(document).off('click.activityDetector').off('touchstart.activityDetector').on('click.activityDetector touchstart.activityDetector',function(){
			if(typeof window.inactivityTime != "undefined"){
				window.inactivityTime = 0;
			}
		})




		/*****************************/

		$('[data-menu-games] [data-coreToggle]').off('afterShow').on('afterShow',function(){
		 	if($(this).closest('li[data-nomenu]').length == 0){
				var thisElem=$(this).closest('li').attr('data-gameType');
				$("#menu-gamesMode ul").removeClass('is-active');
				var menuElem=$("#menu-gamesMode ul[data-gameType='"+thisElem+"']");
				if( $(menuElem).length == 1 ){
				 	$(menuElem).addClass('is-active');
				}
		   }else{
			   var thisElem="";
				$("#menu-gamesMode ul").removeClass('is-active');
		   }
		})

		$('[data-coretoggle="menu-lang"].singlemode').on('afterShow',function(){
		    var currentLang = $(this).find('[data-lang]').attr('data-lang');
		    $('#menu-lang li[data-lang="'+currentLang+'"]').hide();
		})



		/********************/
		/*	 CAMBIO IDIOMA	*/
		/********************/
		$('#menu-lang:not(.singlemode) button:not([data-save-lang])').add('#menu-lang-mobile button:not([data-save-lang])').on('click',function(){
			if($(this).closest('[data-menu-lang]').attr('id') == "menu-lang"){
				var elem = $('#menu-lang:not(.singlemode)');
			}else if($(this).closest('[data-menu-lang]').attr('id') == "menu-lang-mobile"){
				var elem = $('#menu-lang-mobile');
			}
			$(elem).find('[data-save-lang]').removeAttr('disabled');
			if(typeof $(this).attr('data-curr') != "undefined"){
				$(elem).find('button[data-curr]').removeClass('is-active');
			}else if(typeof $(this).attr('data-lang') != "undefined"){
				$(elem).find('button[data-lang]').removeClass('is-active');
			}
			if($(this)[0].nodeName != "SELECT"){
				$(this).addClass('is-active');
			}
		})
		$('#menu-lang select').on('change',function(){
			if($(this).closest('[data-menu-lang]').attr('id') == "menu-lang"){
				var elem = $('#menu-lang:not(.singlemode)');
			}
			$(elem).find('[data-save-lang]').removeAttr('disabled');
		})
		$('#menu-lang:not(.singlemode) button[data-save-lang]').add('#menu-lang-mobile button[data-save-lang]').on('click',function(){
			if($(this).closest('[data-menu-lang]').attr('id') == "menu-lang"){
				var elem = $('#menu-lang:not(.singlemode)');
				var currentCurrency = $(elem).find('select').val();
			}else if($(this).closest('[data-menu-lang]').attr('id') == "menu-lang-mobile"){
				var elem = $('#menu-lang-mobile');
				var currentCurrency = $(elem).find('[data-curr].is-active').attr('data-curr')
			}
			var currentURL = $(elem).find('[data-lang][data-url].is-active').attr('data-url')
			window.location=currentURL+"&currency="+currentCurrency;
		})

		$('#menu-lang.singlemode [data-lang] button').add('#menu-lang-mobile [data-lang] button').on('click',function(){
			var url=$(this).attr('data-url');
			var value=$(this).text();
			if($(this).closest('[data-menu-lang]').attr('id') == "menu-lang"){
				$('[data-coreToggle="menu-lang"] [data-lang]').text(value);
			}else if($(this).closest('[data-menu-lang]').attr('id') == "menu-lang-mobile"){
				$('[menu-lang-mobile] [data-lang]').text(value);
			}
			window.location=url;
		});

		/********************/
		/*	 NOTIFICACIONES	*/
		/********************/
		$("[data-notifications]").on("click",function(){ // Ajax que carga las notificaciones
			openNotificationsBox()
		});


		setTimeout(function(){
			$('[data-top-menu-gamesnav]').animate({scrollLeft: 70}, 1000);
			$('[data-top-menu-gamesnav]').animate({scrollLeft: 0}, 1000);
		}, 1000)

		checkMenuExcess('.top-subMenu','[data-menu-games]');
		checkMenuExcess('[data-inlineGamesMenuContainer]','[data-inlineGamesMenu]');

		$('[data-gamingtabs] li a').on('click',function(e){
			var mobileCompanion = $(e.target);

			$('[data-gamingtabs] li').removeClass('is-active').find('a').removeAttr('aria-selected');
			$('[data-tabs-content="gamingTabs"] > .tabs-panel').removeClass('is-active');
			if(typeof $(mobileCompanion).attr('data-tabs-target') != "undefined"){
				var tg = $(mobileCompanion).attr('data-tabs-target');
				var elem = $('[data-top-menu-gamesnav]').find('[data-tab-id='+tg+']');
				var optionTag = $(mobileCompanion).parent().attr('data-option-tag');

				if(typeof $(elem).attr('data-hidden') != "undefined"){
					$('body').attr('data-notShowingSubMenu','');
				}else{
					$('body').removeAttr('data-notShowingSubMenu');
				}

				if(typeof elem != "undefined" && $(elem).length > 0){
					$('[data-top-menu-gamesnav] > ul').removeClass('is-active')
					$(elem).addClass('is-active')
				}

			}
			if(typeof core_library != "undefined"){
				core_library.closeall()
			}
			checkMenuExcess('.top-subMenu','[data-menu-games]');
			checkMenuExcess('[data-inlineGamesMenuContainer]','[data-inlineGamesMenu]');

		})
		$('[data-gamingtabs] li a').on('click',function(){
			if(!Foundation.MediaQuery.atLeast('large')){
				$('html, body').animate({
					scrollTop: 0
				}, 1000);
			}
		})
		function setGamingTabFromCookie(){
/*
			if(typeof getCookie != "undefined" && $('[data-gamingtabs]').length > 0){
				if(getCookie("gamingTab") != ""){
					var IDtargetToShow = $('[data-gamingtabs] li:eq('+getCookie("gamingTab")+') [data-tabs-target]').attr('data-tabs-target');
					$('[data-gamingtabs]').foundation('selectTab',$('#'+IDtargetToShow));
				}
			}
*/
		}

// 		setGamingTabFromCookie();

		$(document).on('click','[data-menu-viewmore] a,[data-menu-viewmore] button',function(e){
			if($(e.target).closest('[data-menu-games]').length > 0){
				menuExcessNextItem('.top-subMenu','[data-menu-games]');
			}else if($(e.target).closest('[data-inlineGamesMenu]').length > 0){

				menuExcessDropdownActions('[data-inlineGamesMenuContainer]','[data-inlineGamesMenu]','#overflown-gamesCategories');
// 				menuExcessNextItem('[data-inlineGamesMenuContainer]','[data-inlineGamesMenu]',{stickToLast:true});
			}
		})

		$('[data-sectionsNavigator] a[data-tabs-target]').off('click').on('click',function(){
			var tabId = $(this).closest('[data-tabs]').attr('id')
			var tabTag = $(this).closest('[data-option-tag]').attr('data-option-tag')
			$(this).closest('[data-tabs]').find('[tabs-title] a').each(function(){
				$(this).removeAttr("aria-selected")
			})
			$(this).attr('aria-selected','true')
			var lnAnchor = $(this).attr('data-tabs-target');
			$('[data-tabs-content="'+tabId+'"] .tabs-panel').removeClass('is-active');
			$('[data-tabs-content="'+tabId+'"]').find('#'+lnAnchor).addClass('is-active');
			$('[data-gamingtabs] [data-option-tag]').removeClass('is-active').find('a').removeAttr('aria-selected');
			$('[data-gamingtabs] [data-option-tag="'+tabTag+'"]').addClass('is-active').find('a').attr('aria-selected',true);
		})

	})

	$(window).resize();
	sbMenusTimer=false;

	function setResizeEvents(){
		$(window).off('resize.events').on('resize.events',function(){
			if ( typeof core_library == "object" ){
				core_library.closeall()
			}

			if(getFullVersionEnvironment()){
				if(typeof sbMenusTimerThree != "undefined"){clearTimeout(sbMenusTimerThree);}
					sbMenusTimerThree = setTimeout(function(){
						if($('#overflown-gamesCategories:visible').length > 0){
							$('#overflown-gamesCategories').foundation('close');
						}
						checkMenuExcess('.top-subMenu','[data-menu-games]');
						checkMenuExcess('[data-inlineGamesMenuContainer]','[data-inlineGamesMenu]');
				}, 30)
			}
		})
	}

// })

function checkMenuExcess(containerSelector,listItemsSelector,options){
	var container = containerSelector;
	var items = containerSelector + " " + listItemsSelector;
	var height = $(listItemsSelector+ " > *:eq(0)").height();

	var stickViewMoreToLastItem = false;
	if(typeof options != "undefined"){
		if(typeof options.stickToLast != "undefined" && options.stickToLast === true){
			stickViewMoreToLastItem = true;
		}
	}
	if(typeof Foundation !="undefined"){
		if(Foundation.MediaQuery.atLeast('medium')){
			if( $(items + ':visible').height() > height){
				$(container + ' [data-menu-viewmore]').addClass('is-active')
				if(stickViewMoreToLastItem){
					stickViewMoreToLast(containerSelector,listItemsSelector)
				}
				$(container).addClass('is-overflown')

			}else{
				$(container).removeClass('is-overflown')
				$(container + ' [data-menu-viewmore]').removeClass('is-active')
				resetExcessPosition(containerSelector,listItemsSelector);
			}
		}
	}
}

function stickViewMoreToLast(containerSelector,listItemsSelector){
	var container = containerSelector;
	var items = containerSelector + " " + listItemsSelector;
	var height = $(listItemsSelector+ " > *:eq(0)").height();
	var lastVisibleItem = false;
	$($(items + ':visible' + " > li:not([data-menu-viewmore])")).each(function(){
		if($(this).position().top < height){
			lastVisibleItem = $(this);
		}
	})
	if(lastVisibleItem){
		$(container + ' [data-menu-viewmore]').css({
			right:"none"
		})
		$(container + ' [data-menu-viewmore]').animate({
			left:$(lastVisibleItem).position().left + $(lastVisibleItem).outerWidth()
		})
	}
}

function menuExcessNextItem(containerSelector,listItemsSelector,options){
	var container = containerSelector;
	var items = containerSelector + " " + listItemsSelector;
	var stickViewMoreToLastItem = false;
	if(typeof options != "undefined"){
		if(typeof options.stickToLast != "undefined" && options.stickToLast === true){
			stickViewMoreToLastItem = true;
		}
	}
	var containerHeight = $(containerSelector).outerHeight()
	var pages = parseInt($(items + ':visible').outerHeight() / containerHeight )
	var elemHeight = $(items + ':visible li:eq(0)').outerHeight()
	var currentTop = $(items + ':visible li:eq(0)').position().top;
	var currentPage = parseInt(Math.abs(currentTop)/Math.abs(Math.floor(containerHeight))) + 1;

	$(items + ':visible li:not([data-menu-viewmore])').each(function(){
		var page = parseInt(Math.abs($(this).position().top)/Math.abs(Math.floor(containerHeight))) + 1;
		$(this).attr('data-page',page)
	})
	var itemsToMove = $(items + ':visible li')
	var endAnim = $(itemsToMove).length;

	if(currentPage < pages){
		$(items + ':visible li').animate({
			top:"-="+elemHeight
		},300,function(){
			endAnim--;
			if(endAnim == 0){
				if(stickViewMoreToLastItem){
					stickViewMoreToLast(containerSelector,listItemsSelector,options)
				}
			}
		})
		$(items + ':visible li:not([data-menu-viewmore])').each(function(){
			if($(this).attr('data-page') != currentPage){
				$(this).css('visibility','visible')
			}else{
				$(this).css('visibility','hidden')
			}
		})
	}else{
		$(items + ':visible li').animate({
			top:0
		},300,function(){
			endAnim--;
			if(endAnim == 0){
				if(stickViewMoreToLastItem){
					stickViewMoreToLast(containerSelector,listItemsSelector,options)
				}
			}
		})
		$(items + ':visible li:not([data-menu-viewmore])').each(function(){
			if($(this).attr('data-page') != currentPage){
				$(this).css('visibility','hidden')
			}else{
				$(this).css('visibility','visible')
			}
		})
	}

}
function menuExcessDropdownActions(containerSelector,listItemsSelector,dropdownItem){
var container = containerSelector;
	var items = containerSelector + " " + listItemsSelector;
	var height = $(listItemsSelector+ " > *:eq(0)").height();

	if(typeof Foundation !="undefined"){
		if(Foundation.MediaQuery.atLeast('medium')){

			$(items + ':visible li:not([data-menu-viewmore])').each(function(k,v){
				if(k != 0){ //ignoramos el primer elemento, y restamos 1 al equivalente del dropdown, porque "loteria (elemento 0)" siempre está presente
					if(parseInt($(this).position().top) >= parseInt(height)){
						$(dropdownItem).find('li:eq(' + ($(this).index() - 1) + ')').addClass('visible');
					}else{
						$(dropdownItem).find('li:eq(' + ($(this).index() - 1) + ')').removeClass('visible');
					}
				}
			})
		}
	}
}
function resetExcessPosition(containerSelector,listItemsSelector){
	var container = containerSelector;
	var items = containerSelector + " " + listItemsSelector;
	$(items + ':visible li').animate({
		top:0
	},300).css('visibility','visible')
}

function manageSlideMotion(elem,startPos,time,timeToWakeUpFromTouch,startAnimating){

	var selector = $(elem)

	inicializaScrollArea()
	var initWithAnimation = true
	var start = 0
	var timer = 10000 //Para 320 de ancho (movil minimo)
	var multiplicador = 1 //Para ajustar tiempos al ancho
	var holdTime = 3000
	var holdTimeInterval = false
	var totalScrollableArea =$(selector)[0].scrollWidth -  $(selector).width()
	var direction = "right"
	var resizeId;

	multiplicador = $(document).width() / 320

	if(typeof startPos != "undefined"){ start = startPos}
	if(typeof time != "undefined"){ timer = time}
	if(typeof timeToWakeUpFromTouch != "undefined"){ holdTime = timeToWakeUpFromTouch}
	if(typeof startAnimating != "undefined"){ initWithAnimation = startAnimating}


	var totalToScroll = 0
	var isHover = false

	function inicializaScrollArea(){
		//calculamos e iniciamos barra de scroll
		if(!Foundation.MediaQuery.atLeast('large')){
			var max = 0
			$(selector).find(' > div > *').each(function(k,v){
				max = max + $(this).outerWidth(true)
			})
			$(selector).find(' > div').css('width',max+'px')
		}
	}

	$(selector).scrollLeft(start)

	if(initWithAnimation){
		$(selector).off('scroll').on('scroll',function(){
			if( $(selector).scrollLeft() >= totalScrollableArea ){
				$(selector).stop().finish()
				start = 0
				if(!isHover){
					animateToLeft()
				}
			}
			if( $(selector).scrollLeft() <= 0 ){
				$(selector).stop().finish()
				start = 0
				if(!isHover){
					animateToRight()
				}
			}
		})

		$(selector).trigger('scroll')
		$(selector).on('touchstart mouseenter',function(e){
			start = $(selector).scrollLeft()
			$(selector).stop().finish()
			isHover = true
		})

		$(selector).on('touchend mouseleave',function(e){
			clearTimeout(holdTimeInterval)
			start = $(selector).scrollLeft()
			holdTimeInterval = setTimeout(function(){
				if(direction == "right"){
					animateToRight()
				}else{
					animateToLeft()
				}
			}, holdTime)

			isHover = false
		})

		if (getFullVersionEnvironment()){
			$(window).on('resize',function(){
				clearTimeout(resizeId);
				resizeId = setTimeout(function(){
					inicializaScrollArea()
					multiplicador = $(document).width() / 320
					$(selector).removeClass('non-scrollable')

					if($(selector).find(' > div').width() > $(selector).width()){
						if(direction == "right"){
							animateToRight()
						}else{
							animateToLeft()
						}
					}else{
						$(selector).addClass('non-scrollable')
					}
				}, 1500);
			})
		}
	}
	function animateToRight(){
		direction = "right"
		totalToScroll = totalScrollableArea-start
		if($(selector).find(' > div').width() > $(selector).width()){
			$(selector).removeClass('non-scrollable')
			if($(selector).scrollLeft() >= totalScrollableArea){ //Esto es porque hemos llegado a los extremos manualmente
				animateToLeft()
			}else{
				var newTime = (totalToScroll * timer) / totalScrollableArea
				newTime = newTime / multiplicador
				$(selector).animate( { scrollLeft: '+='+ totalToScroll}, newTime, "linear",  function(){} );
			}
		}else{
			$(selector).addClass('non-scrollable')
		}
	}
	function animateToLeft(){
		direction = "left"
		totalToScroll = (start - totalScrollableArea) * (-1)
		if($(selector).find(' > div').width() > $(selector).width()){
			$(selector).removeClass('non-scrollable')
			if($(selector).scrollLeft() <= 0){ //Esto es porque hemos llegado a los extremos manualmente
				animateToRight()
			}else{
				var newTime = (totalToScroll * timer) / totalScrollableArea
				newTime = newTime / multiplicador
				$(selector).animate( { scrollLeft: '-='+ totalToScroll}, newTime, "linear", function(){} );
			}
		}else{
			$(selector).addClass('non-scrollable')
		}
	}
}

function GetIEVersion() {
  var sAgent = window.navigator.userAgent;
  var Idx = sAgent.indexOf("MSIE");

  // If IE, return version number.
  if (Idx > 0)
    return parseInt(sAgent.substring(Idx+ 5, sAgent.indexOf(".", Idx)));

  // If IE 11 then look for Updated user agent string.
  else if (!!navigator.userAgent.match(/Trident\/7\./))
    return 11;

  else
    return 0; //It is not IE
}



function enableLoaderWatch(){
	hideMobileMenu();
	$(document).off('click','#mobileGamesMenuOverlay').on('click','#mobileGamesMenuOverlay',function(){
		hideMobileMenu();
	})

	$('[data-mobileGamesMenuToggle]').on('click',function(){
		if(!$('#mobileGamesMenu').is(":visible")){
			showMobileMenu();
		}else{
			hideMobileMenu();
		}
		if($('#mobileGamesMenu').is(":visible")){
			$('[data-mobileGamesMenuToggle]').addClass('is-opened').removeClass('is-closed');
		}else{
			$('[data-mobileGamesMenuToggle]').removeClass('is-opened').addClass('is-closed');
		}
	})



	$('#mobileGamesMenu  ul > li').each(function(){
		if($(this).find('ul').length>0){
			$(this).addClass( 'has-submenu' );
			var menuElem=$(this);
			$(this).find('a:eq(0)').click(function(){
				var elemToDeploy=$(this).parent().find('ul:eq(0)');
				$(elemToDeploy).slideToggle('fast',function(){
					if($(elemToDeploy).is(':visible')){
						$(menuElem).addClass('is-opened');
					}else{
						$(menuElem).removeClass('is-opened');
					}
				});

			})
		}
	})
	$('body').attr('data-isloaded','');
}
function hideMobileMenu(){
	$('[data-mobileGamesMenuToggle]').removeClass('is-opened');
	$('#mobileGamesMenu').hide().removeClass('is-open');
	$('#mobileMenu').removeClass('is-open')
	$('#mobileGamesMenuOverlay').remove();
	$('body').removeAttr('data-mobile-menu');
}
function showMobileMenu(){
	$('#mobileGamesMenu').show().addClass('is-open');
	$('#mobileMenu').addClass('is-open')
	$('#superContainer').append('<div class="reveal-overlay" id="mobileGamesMenuOverlay"></div>');
	$('body').attr('data-mobile-menu','is-open');
}
function menuEvents(){
	$('#mobileGamesMenu').off('show.zf.dropdown').on('show.zf.dropdown',function(){
		$('[data-mobileGamesMenuToggle]').addClass('is-opened').removeClass('is-closed');
		$('#mobileMenu').addClass('is-open')
		$('#superContainer').append('<div class="reveal-overlay" id="mobileGamesMenuOverlay"></div>');
	})

	$('#mobileGamesMenu').off('hide.zf.dropdown').on('hide.zf.dropdown',function(){
		$('[data-mobileGamesMenuToggle]').removeClass('is-opened').addClass('is-closed');
		$('#mobileMenu').removeClass('is-open')
		$('#mobileGamesMenuOverlay').remove();

	})



}


bamQueue.waitForExistance("Foundation",function(){

	//Foundation.Abide.defaults.patterns["passwordReset"] = /^(.){8,}$/;

	/********************/
	/*	 MENU MOVIL		*/
	/********************/


/*
	$('#mobileGamesMenu').off('show.zf.dropdown').on('show.zf.dropdown',function(){
		$('[data-mobileGamesMenuToggle]').addClass('is-opened').removeClass('is-closed');
		$('#mobileMenu').addClass('is-open')
		$('#superContainer').append('<div class="reveal-overlay" id="mobileGamesMenuOverlay"></div>');
	})

	$('#mobileGamesMenu').off('hide.zf.dropdown').on('hide.zf.dropdown',function(){
		$('[data-mobileGamesMenuToggle]').removeClass('is-opened').addClass('is-closed');
		$('#mobileMenu').removeClass('is-open')
		$('#mobileGamesMenuOverlay').remove();

	})
	$('#mobileGamesMenu > ul > li').each(function(){
		if($(this).find('ul').length>0){
			$(this).addClass( 'has-submenu' );
			var menuElem=$(this);
			$(this).find('a:eq(0)').click(function(){
				var elemToDeploy=$(this).parent().find('ul:eq(0)');
				$(elemToDeploy).slideToggle('fast',function(){
					if($(elemToDeploy).is(':visible')){
						$(menuElem).addClass('is-opened');
					}else{
						$(menuElem).removeClass('is-opened');
					}
				});

			})
		}
	})

*/
	/****************/
	/*	 MODALES	*/
	/****************/
	//CANCELAMOS TODOS LOS EVENTOS REVEAL HASTA CARGAR NUESTROS SCRIPTS QUE LOS GESTIONAN
/*
	if($('[data-reveal]').length>0){
		if(GetIEVersion()==0 || GetIEVersion()>11){
			try{
				$('[data-reveal]').foundation('destroy');
			}
			catch{

			}

		}
	}
*/

	/********************************************/
	/*	 FIXED TOOLBAR + FLOATING BUTTONS		*/
	/********************************************/
	$(window).scroll(function() {
		if(typeof scrollFinished != "undefined"){ clearTimeout(scrollFinished) }
		scrollFinished = setTimeout(function(){
			if($('#notifications:visible').length>0){
				$('#notifications').core_reveal('close')
			}
			var topMenuOffset=0;
			if($('body').hasClass('hasFixedAd')){
				topMenuOffset=$('.top-menu').position().top;
			}
			if( $(window).scrollTop() >= 48 &&  Foundation.MediaQuery.atLeast('large') && $('body[data-app]').length == 0) {
				$('.top-subMenu,.top-menu,body').addClass('setFixed')
					checkMenuExcess('.top-subMenu','[data-menu-games]');
					checkMenuExcess('[data-inlineGamesMenuContainer]','[data-inlineGamesMenu]');
			}else{
				$('.top-subMenu,.top-menu,body').removeClass('setFixed');
					checkMenuExcess('.top-subMenu','[data-menu-games]');
					checkMenuExcess('[data-inlineGamesMenuContainer]','[data-inlineGamesMenu]');
			}
			if ( $('[data-top-menu-gamesnav]').length > 0 &&  $(window).scrollTop() >= Math.abs( ($('[data-top-menu-gamesnav]').outerHeight()-parseInt($('[data-top-menu-gamesnav]').css('padding-top')))) && !Foundation.MediaQuery.atLeast('large') ){

					$('body').attr('data-categoryTabs-hidden','true');
					$('[data-gamingTabs]').slideUp(200)

			}else{

					$('body').removeAttr('data-categoryTabs-hidden');
					$('[data-gamingTabs]').slideDown(200)
			}

			//Botones laterales
			if( $(window).scrollTop() >= 50 && !Foundation.MediaQuery.atLeast('large')){
				$('#sidebarMenus').removeClass('is-active');
				if($('#sidebarMenus').is(':visible')){
					$('#sidebarMenus').hide()
				}
			}else{
				$('#sidebarMenus').show()
				$('#sidebarMenus').addClass('is-active');
			}
			if($('#overflown-gamesCategories:visible').length > 0){
				$('#overflown-gamesCategories:visible').foundation('close');
			}
		}, 130)
	})



},500)

function removeMarqueeAlert(elem){
	if($(elem).closest('[data-alertsMarquee]').length == 0 || ($(elem).closest('[data-alertsMarquee]').length > 0 && $(elem).closest('ul').find('li').length > 1) ){
		$(elem).closest('li').slideUp(function(){
			$(elem).remove();
		});
	}else{
		$(elem).closest('[data-alertsMarquee]').slideUp(function(){
			$(this).remove();
		})
	}
};

function setAppTouchIDinUse(inUse){ //Si tiene capacidad TouchID, establecemos true o false si tiene la autentificacion por huella activada
	$('body').attr('data-touchIDinUse',inUse)
	$('#myConfig [data-touchId]').show();
	if(inUse=="true"){
		$('#myConfig #touchIDSwitch').prop('checked',true);
	}else{
		$('#myConfig #touchIDSwitch').prop('checked',false);
	}
}

function is_touch_device() {

    var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');

    var mq = function (query) {
        return window.matchMedia(query).matches;
    }

    if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
        return true;
    }

    // include the 'heartz' as a way to have a non matching MQ to help terminate the join
    // https://git.io/vznFH
    var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
    return mq(query);
}

function dismissFloatingNotification(timeToKill,elem){
	var ttk = 800;
	if(typeof timeToKill != "undefined" && timeToKill != null){
		ttk = timeToKill;
	}
	if(typeof $ != "undefined"){
		if(typeof elem != "undefined"){
			var daddy = $(elem).closest('[data-floatingNotifier]');
		}else{
			var daddy = $('[data-floatingNotifier]');

		}
		$(daddy).removeClass('is-active');
		setTimeout(function(){
			$(daddy).remove();
		}, ttk)
	}
}

function dismissCookies(elem){
	if(typeof $ != "undefined"){
		var cookiesRequestSelector = "[data-cookiesRequest]";
		if($(elem).closest('[data-reveal-source="login"]').length > 0){
			if(typeof login != "undefined"){
				login.open();
			}
			dismissFloatingNotification(null,elem);
		}else{
			location.reload();
		}
	}
}

// check_webp_feature:
//   'feature' can be one of 'lossy', 'lossless', 'alpha' or 'animation'.
//   'callback(feature, result)' will be passed back the detection result (in an asynchronous way!)
function check_webp_feature(feature, callback) {
	var kTestImages = {
		lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
		lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
		alpha: "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
		animation: "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"
	};
	var img = new Image();
	img.onload = function () {
		var result = (img.width > 0) && (img.height > 0);
		callback(feature, result);
	};
	img.onerror = function () {
		callback(feature, false);
	};
	img.src = "data:image/webp;base64," + kTestImages[feature];
}

lazyLoader();
function lazyLoader(){
	//document.addEventListener("DOMContentLoaded", function() {
		var lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy"));

		if ("IntersectionObserver" in window) {
		  let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
			entries.forEach(function(entry) {
			  if (entry.isIntersecting) {
				entry.target.classList.add("visible");
				lazyBackgroundObserver.unobserve(entry.target);
			  }
			});
		  });
		  lazyBackgrounds.forEach(function(lazyBackground) {
			lazyBackgroundObserver.observe(lazyBackground);
		  });
		}else{
			lazyBackgrounds.forEach(function(v){
				v.classList.add("visible");
			})
		}
	//  });
}
function unlock(selectorsToUnlock,attributeToRemove){
	//Elimina el atributo 'disabled' de los selectores pasados.
	//Normalmente se usa data-lock como atributo, por normalizar
	//Si el atributo 'data-forceLock" existe, mantiene el estado disabled ignorando la función
	$(selectorsToUnlock).each(function(){
		if(typeof $(this).attr('data-forceLock') == "undefined"){
			$(this).removeAttr('disabled');
		}
		if(attributeToRemove){
			$(this).removeAttr(attributeToRemove);
		}
	})
}
function lock(selectorsToUnlock,attrToAdd){
	//Se puede usar por ejemplo [data-locked] como atributo
	$(selectorsToUnlock).each(function(){
		$(this).attr('disabled','disabled').attr(attrToAdd,'');
	})
}